import React, { useState } from 'react';
import Form from '../Login/Form';

import { auth } from '../../firebase';
import { createUserWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth';
import HomeButton from '../../components/HomeButton';

const Register = () => {

    const [registerEmail, setRegisterEmail] = useState("");
    const [registerPassword, setRegisterPassword] = useState("");

    const [user, setUser] = useState({});

    onAuthStateChanged(auth, (currentUser) => {
        setUser(currentUser);
    })

    const register = async () => {
        try {
            const user = await createUserWithEmailAndPassword(
                auth,
                registerEmail,
                registerPassword
            )
            alert(`Usuario com email ${registerEmail} registrado`)
            window.location.href = "/"
        } catch (error) {
            alert(error.message)
        }
    }

    return (
        <>
            <div className="container">
                <HomeButton />
                <div className="row text-center justify-content-center p-5">
                    <Form
                    welcome={"Prazer em conhece-lô(a)!"} 
                    submitBtn={"Registrar"}
                    setEmail={setRegisterEmail}
                    setPassword={setRegisterPassword} 
                    login={register} />
                </div>
            </div>
        </>
    )
}

export default Register